import { BaseModal } from "../../molecules/modal/base-modal";
import * as React from "react";
import { useState } from "react";
import { SurveyEntity } from "../../../application/domain/surveys/survey-entity";
import { TextField } from "@graffer-inc/console-design-kit";

export const CreateSurveyModal: React.FC<{
  onClose: () => void;
  selectedGroupId: string;
  onSave: (name: string) => void;
  children: React.ReactNode;
}> = ({ onClose, selectedGroupId, onSave, children }) => {
  const [name, setName] = useState("");

  return (
    <BaseModal
      hasOverflow={true}
      title={"新規作成"}
      isActive={true}
      onClose={onClose}
    >
      <div className="modal-card-body">
        <div className="field">
          <TextField
            label={"アンケート名称"}
            description={"アンケート名称を入力してください。"}
            placeholder={""}
            onChange={(e) => setName(e.target.value)}
            value={name}
            errorMessages={SurveyEntity.validateName(name)}
            required
          />
        </div>
        <div className="field">
          {/* TODO(twakino):fe-smart-apply-consoleにてauthContextを実装次第、Group選択コンポーネントを実装する*/}
          <div className="control">{children}</div>
        </div>
      </div>
      <footer className="modal-card-foot">
        <button
          className="button is-failure is-fullwidth"
          onClick={() => onClose()}
        >
          キャンセル
        </button>
        <button
          className="button is-info is-fullwidth"
          onClick={() => onSave(name)}
          disabled={!!SurveyEntity.validateName(name) || !selectedGroupId}
        >
          作成する
        </button>
      </footer>
    </BaseModal>
  );
};
